import React from 'react';
import { FiX } from 'react-icons/fi';

const TransactionViewModal = ({ isOpen, onClose, transaction }) => {
    if (!isOpen || !transaction) return null;

    // Determine Transaction Type (Receipt or Payment)
    // Receipt (Jama): Cash/Bank is DEBIT (Nave), Accounts are CREDIT (Jama)
    // Payment (Nave): Cash/Bank is CREDIT (Jama), Accounts are DEBIT (Nave)
    // "जमा व्हॉटचर" = Receipt
    // "नावे व्हॉटचर" = Payment
    // "बँक नावे" = Payment
    // "बँक जमा" = Receipt
    const isPayment = transaction.voucherType && (transaction.voucherType.includes('नावे') || transaction.voucherType.includes('payment'));
    
    // Determine Contra Account Name
    const isBank = transaction.voucherType && (transaction.voucherType.includes('बँक') || transaction.voucherType.includes('Cheque'));
    const contraAccountName = isBank ? (transaction.bankName || 'बँक खाते') : 'रोख शिल्लक';
    const contraAccountId = isBank ? '-' : '501'; // 501 is typical for Cash in Hand

    // Calculate Totals
    const totalAmount = parseFloat(transaction.totalAmount || 0);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 font-poppins">
            <div className="bg-white rounded shadow-lg w-[800px] overflow-hidden animate-fade-in-up">
                {/* Header */}
                <div className="bg-blue-800 text-white p-2 px-4">
                     <h2 className="text-lg">व्यवहार माहिती</h2>
                </div>

                <div className="p-6 pb-0">
                    {/* Date and Challan Info */}
                    <div className="flex justify-between items-center mb-4 text-gray-800 text-sm md:text-base">
                        <div className="flex items-center">
                            <span className="font-medium mr-2">व्यवहार दिनांक</span>
                            <span>{transaction.date ? transaction.date.split('-').reverse().join('/') : ''}</span>
                        </div>
                        <div className="flex items-center">
                             <span className="font-medium mr-2">चलन क्रमांक</span>
                             <span>{transaction.challanNo || '1'}</span>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="border border-blue-900 mb-6">
                        <table className="w-full text-center border-collapse">
                            <thead className="bg-blue-900 text-white text-sm">
                                <tr>
                                    <th className="border-r border-blue-800 p-2 font-normal w-32">खातावणी क्र.</th>
                                    <th className="border-r border-blue-800 p-2 font-normal text-left pl-4">खाते</th>
                                    <th className="border-r border-blue-800 p-2 font-normal w-32">नावे रक्कम</th>
                                    <th className="p-2 font-normal w-32">जमा रक्कम</th>
                                </tr>
                            </thead>
                            <tbody className="text-sm">
                                {/* Transaction Rows (The Split) */}
                                {transaction.transactions && transaction.transactions.map((t, idx) => (
                                    <tr key={idx} className="border-b border-gray-300 text-gray-800 hover:bg-gray-50">
                                        <td className="border-r border-gray-300 p-2">{t.accountId || '-'}</td>
                                        <td className="border-r border-gray-300 p-2 text-left pl-4">{t.accountName}</td>
                                        <td className="border-r border-gray-300 p-2 text-right pr-4">
                                            {isPayment ? parseFloat(t.amount).toFixed(0) : '0'}
                                        </td>
                                        <td className="p-2 text-right pr-4">
                                            {!isPayment ? parseFloat(t.amount).toFixed(0) : '0'}
                                        </td>
                                    </tr>
                                ))}

                                {/* Contra Row (Cash/Bank) */}
                                <tr className="border-b border-gray-300 text-gray-800 hover:bg-gray-50">
                                    <td className="border-r border-gray-300 p-2">{contraAccountId}</td>
                                    <td className="border-r border-gray-300 p-2 text-left pl-4">{contraAccountName}</td>
                                    <td className="border-r border-gray-300 p-2 text-right pr-4">
                                        {!isPayment ? totalAmount.toFixed(0) : '0'}
                                    </td>
                                    <td className="p-2 text-right pr-4">
                                        {isPayment ? totalAmount.toFixed(0) : '0'}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Button */}
                <div className="bg-blue-800 p-3 flex justify-center">
                    <button 
                        onClick={onClose}
                        className="bg-green-600 text-white px-8 py-1 rounded shadow hover:bg-green-700 transition-colors"
                    >
                        ठिक
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TransactionViewModal;
